import { z } from "zod"
import { DocumentLanguage } from "@/modules/patients/libs/document-languages"
import { BloodChemistry, Coagulation, Hematology, RapidTest, UrineDiagnostic } from "@/types/__generated__/union-types"

export const MeasLaboratoryPrescriptionSchema = z.object({
  language: z.custom<DocumentLanguage>(),
  bloodChemistries: z.array(z.custom<BloodChemistry>()),
  hematologies: z.array(z.custom<Hematology>()),
  coagulations: z.array(z.custom<Coagulation>()),
  urineDiagnostics: z.array(z.custom<UrineDiagnostic>()),
  rapidTests: z.array(z.custom<RapidTest>()),
})

export type MeasLaboratoryPrescription = z.infer<typeof MeasLaboratoryPrescriptionSchema>
